import { createStyles, Theme } from '@material-ui/core/styles';
import type { DividerProps } from './Divider';

const styles = ({ colors }: Theme) => createStyles({
  root: ({ color }: DividerProps) => ({
    height: '2px',
    background: color || colors.layout.divider300,
  }),
});

export default styles;
